import classNames from 'classnames/bind';
import { MouseEventHandler } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  clickCode: string;
  isChecked: boolean;
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
}

export default function SortOption({
  clickCode,
  isChecked,
  label,
  onClick,
}: IProps) {
  return (
    <button
      type="button"
      className={cx('order')}
      aria-checked={isChecked}
      onClick={onClick}
      data-event-nlog="click"
      data-event-area-code={`rcm.${clickCode}`}
    >
      {label}
    </button>
  );
}
